var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"close-on-content-click":"","nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"indigo","dark":"","icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-dots-horizontal-circle-outline")])],1)]}}])},[_c('v-card',[_c('card-copy-slug',{staticClass:"pa-4",attrs:{"slug":("/khuyen-mai/" + _vm.slug)}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }